import React from 'react';
import { connect } from 'react-redux';
import overrideStyle from 'lib/overrideStyle';
import PropTypes from 'prop-types';

import { getWithinOfficeHours } from 'app/modules';
import { LOCATIONS } from 'app/modules/ui/constants';
import { shiftColorShade } from 'lib/colorLogic.js';
import { startInteractiveOnboarding, navigateForward } from 'app/modules/ui/actions';

function ChatWithAgentButton(props) {
  ChatWithAgentButton.propTypes = {
    buttonText: PropTypes.string.isRequired,
    isWithinOfficeHours: PropTypes.bool.isRequired,
    showOfficeHourMessage: PropTypes.func.isRequired,
    startOnboarding: PropTypes.func.isRequired,
    theme: PropTypes.object.isRequired,
  };

  const message = props.isWithinOfficeHours ? props.buttonText : 'Talk to us';

  const Wrapper = overrideStyle('button')`
    background: ${props.theme.colors.brandPrimary};
    border: none;
    border-radius: 0px 0px 10px 10px;
    color: white;
    font-size: 14px;
    height: 75px;
    justify-content: center;
    margin-right: 0;
    padding: 0;
    &:active {
      background: ${shiftColorShade(props.theme.colors.brandPrimary, 2)};
    }
  `;
  return (
    <Wrapper onClick={props.isWithinOfficeHours ? props.startOnboarding : props.showOfficeHourMessage}>
      {message}
    </Wrapper>
  );
}

export const mapDispatchToProps = dispatch => {
  return {
    startOnboarding: () => {
      dispatch(startInteractiveOnboarding());
      dispatch(navigateForward(LOCATIONS.CHAT));
    },
    showOfficeHourMessage: () => {
      dispatch(navigateForward(LOCATIONS.OFFICE_HOURS));
    },
  };
};

export const mapStateToProps = state => {
  return { isWithinOfficeHours: getWithinOfficeHours(state) };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatWithAgentButton);
